import './assets/css/main.scss'
import 'element-plus/dist/index.css'
import './assets/js/iconfont'

import { createApp } from 'vue'
import store from './stores'
import './permission'
import App from './App.vue'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.mount('#app')
